export default {
    ITEMS_PER_PAGE: 12,
    NAME: "Romain HENRY",
    TITLE: "Développeur Full Stack",
    ABOUT_ME: "À propos",
    DEFAULT_ABOUT_TEXT: "Passionné par le développement web et les nouvelles technologies, je crée des applications modernes et performantes. Quand je ne code pas, vous me trouverez probablement en train d'explorer de nouveaux horizons à travers mes voyages et randonnées.",

    SKILLS_TITLE: "Compétences techniques",
    SKILLS: [
        {
            name: "Python",
            frameworks: "Django, Flask, FastAPI",
            percentage: 90
        },
        {
            name: "JavaScript",
            frameworks: "React, jQuery",
            percentage: 85
        },
        {
            name: "PHP",
            frameworks: "Laravel, Phalcon",
            percentage: 80
        },
        {
            name: "Docker",
            frameworks: "Conteneurisation",
            percentage: 80
        },
        {
            name: "Kubernetes",
            frameworks: "Orchestration",
            percentage: 70
        },
        {
            name: "Git",
            frameworks: "Contrôle de version",
            percentage: 90
        }
    ],

    // Projets personnels — bloc affiché sous les compétences (page d'accueil).
    // Le contenu des cartes vient de l'API (table projects) : seul le titre de
    // la section reste ici.
    PROJECTS_TITLE: "Projets personnels",

    // Politique de confidentialité OpenPeaks (page /openpeaks/privacy)
    OPENPEAKS_PRIVACY: {
        appName: "OpenPeaks",
        lastUpdated: "26 juillet 2026",
        contactEmail: "romainhenry60@gmail.com",
        editor: "Romain Henry",
    },

    MY_TRAVELS: "Mes voyages",
    MY_TREKS: "Mes randonnées",
    GALLERY: "Galerie",
    DEVELOPPER: "Développeur",
    TREKKER: "Randonneur",
    TRAVELER: "Voyageur",
    AT_MONACO: "@Monaco 🇲🇨",
    LINKEDIN_URL: "https://linkedin.com/in/romain-henry-9975a8166",
    GITHUB_URL: "https://github.com/romainh3nry",
    PROFIL_PICTURE: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    NO_ALBUMS_MESSAGE: "Aucun albums disponible pour le moment.",
    NO_IMAGE_MESSAGE: "Pas d'image",
    SEE_ALBUM: "Voir l'album",
    LOADING: "Chargement...",
    LOADING_ALBUM: "Chargement de l'album...",
    ERROR: "Erreur",
    ALBUM_NOT_FOUND: "Album non trouvé",
    UNABLE_TO_LOAD_ALBUM: "Impossible de charger l'album",
    BACK_TO_GALLERY: "Retour à la galerie",
    NO_PHOTOS_IN_ALBUM: "Aucune photo dans cet album",
    PHOTO: "Photo",
    
    // Travel Section
    TRAVEL_INTRO: "Découvrez les pays que j'ai eu la chance de visiter à travers mes voyages. Chaque destination raconte une histoire unique, des paysages époustouflants aux rencontres enrichissantes.",
    NO_TRAVELS_AVAILABLE: "Aucun voyage disponible",
    NO_IMAGE_AVAILABLE: "Aucune image disponible",
    TRAVEL_DATE_LABEL: "📅 Voyage en",
    
    // Travel Page
    LOADING_TRAVEL: "Chargement du voyage...",
    TRAVEL_NOT_FOUND: "Voyage non trouvé",
    UNABLE_TO_LOAD_TRAVEL: "Impossible de charger les informations du voyage",
    BACK_TO_TRAVELS: "Retour aux voyages",
    ITINERARY: "L'itinéraire",
    TRIP_FACTS: "Le voyage en chiffres",
    TRIP_STAGES: "Étapes",
    TRIP_DAYS: "Jours",
    TRIP_PERIOD: "Période",
    SEE_STAGE: "Voir l'étape",
    NO_PLACES_MESSAGE: "Aucun lieu visité enregistré pour ce voyage",
    COUNTRY_NOT_FOUND: "Pays non trouvé",
    DEFAULT_COUNTRY_FLAG: "🌍",
    DATE_LOCALE: "fr-FR",
    SHOW_MORE_ALBUMS: "Voir plus",
    
    // Trek Section
    TREK_INTRO: "Découvrez les randonnées que j'ai eu la chance de réaliser à travers les montagnes et sentiers. Chaque trek raconte une aventure unique, des paysages grandioses aux défis personnels.",
    NO_TREKS_AVAILABLE: "Aucune randonnée disponible",
    NO_TREKS_FOR_FILTER: "Aucune randonnée ne correspond à ces filtres",
    FILTER_BY_TAG: "Filtrer par tag",
    SEARCH_TREK_PLACEHOLDER: "Rechercher une randonnée...",
    
    // Trek Page
    LOADING_TREK: "Chargement de la randonnée...",
    TREK_NOT_FOUND: "Randonnée non trouvée",
    UNABLE_TO_LOAD_TREK: "Impossible de charger les informations de la randonnée",
    BACK_TO_TREKS: "Retour aux randonnées",
    
    // Hiking Page
    LOADING_HIKING: "Chargement de la randonnée...",
    HIKING_NOT_FOUND: "Randonnée non trouvée",
    UNABLE_TO_LOAD_HIKING: "Impossible de charger les informations de la randonnée",
    BACK_TO_HIKINGS: "Retour aux randonnées",
    HIKING_DESCRIPTION: "Description",
    HIKING_STATISTICS: "Statistiques",
    DISTANCE: "Distance",
    ELEVATION_GAIN: "Dénivelé positif",
    DURATION: "Durée",
    MAX_ALTITUDE: "Altitude max",
    VIEW_MAP: "Voir la carte",
    HIKING_ROUTE: "Itinéraire",
    TAGS: "Tags",
    
    // Place Page
    LOADING_PLACE: "Chargement de la place...",
    PLACE_NOT_FOUND: "Place non trouvée",
    UNABLE_TO_LOAD_PLACE: "Impossible de charger les informations de la place",
    BACK_TO_TRAVEL: "Retour au voyage",
    PLACE_DESCRIPTION: "Description",
    ACCOMMODATION: "Hébergement(s)",
    ARTICLE_IN_PROGRESS: "Cet article est en cours d'écriture...",
    
    // 404 Page
    PAGE_NOT_FOUND_TITLE: "Page non trouvée",
    PAGE_NOT_FOUND_MESSAGE: "Oups ! La page que vous cherchez semble s'être perdue au cours d'une aventure...",
    BACK_TO_HOME: "Retour à l'accueil",
    EXPLORE_TRAVELS: "Découvrir mes voyages",
    EXPLORE_GALLERY: "Parcourir la galerie",
    
    // 500 Page
    SERVER_ERROR_TITLE: "Erreur serveur",
    SERVER_ERROR_MESSAGE: "Aïe ! Le serveur rencontre quelques difficultés techniques...",
    SERVER_ERROR_DESCRIPTION: "Je travaille dur pour résoudre ce problème. Veuillez réessayer dans quelques instants.",
    TRY_AGAIN: "Réessayer",

    // Maintenance (config MAINTENANCE_MODE = 1)
    MAINTENANCE_TITLE: "Maintenance en cours",
    MAINTENANCE_MESSAGE: "Petite pause au refuge ! Le site est en maintenance pour le moment...",
    MAINTENANCE_DESCRIPTION: "Il revient très vite. Merci de votre patience !",

    // Notification
    CONTACT_FORM_TITLE: "Contactez-moi",
    CONTACT_FORM_EMAIL_LABEL: "Votre email",
    CONTACT_FORM_EMAIL_PLACEHOLDER: "Votre email",
    CONTACT_FORM_MESSAGE_LABEL: "Message",
    CONTACT_FORM_MESSAGE_PLACEHOLDER: "Votre message",
    CONTACT_FORM_SUBMIT: "Envoyer",
    CONTACT_FORM_SENDING: "Envoi...",
    CONTACT_FORM_SUCCESS: "Message envoyé avec succès !",
    CONTACT_FORM_ERROR: "Erreur lors de l'envoi du message.",
}